import {
  Drawer as LibDrawer,
  DrawerProps as LibDrawerProps,
  DrawerTransition as LibDrawerTransition,
  DrawerTransitionProps as LibDrawerTransitionProps,
} from "@flaminem/ui-components";
import { FC } from "react";

import { useFullScreen } from "src/hooks/useFullScreen";
import { useT } from "src/internationalization";

export type DrawerProps = Omit<LibDrawerProps, "languageTexts">;

export const Drawer: FC<DrawerProps> = (props) => {
  const t = useT();

  return (
    <LibDrawer
      {...props}
      languageTexts={{
        close: t("general.actions.close"),
      }}
    />
  );
};

export type DrawerTransitionProps = LibDrawerTransitionProps;

export const DrawerTransition: FC<DrawerTransitionProps> = ({ withPortal, ...props }) => {
  const { active } = useFullScreen();

  return (
    <LibDrawerTransition {...props} withPortal={withPortal === undefined ? !active : withPortal} />
  );
};

export {
  type DrawerError,
  type DrawerInitialFocus,
  type DrawerNotification,
  type DrawerContextType,
  type DrawerReturnFocus,
  useDrawerContext,
} from "@flaminem/ui-components";
